// NodeCard.jsx

import React, { useEffect, useMemo, useState } from 'react';

// Services
import { resolveImageUrl } from 'services/storage/StorageAccessService';

// CSS
import './NodeCard.css';

// Components
import NodeTypePill from 'components/nodetypepill/NodeTypePill';

/**
 * NodeCard
 *
 * @returns {ReactNode} The rendered component.
 */
const NodeCard = ({ node, onClick }) => {

  // ----- MEMOS ----- //

  // Determine which cover image to show: only use the node's own coverUrl

  const coverUrl = useMemo(() => {
    if (typeof node?.coverUrl === 'string') {
      const trimmed = node.coverUrl.trim();
      return trimmed.length > 0 ? trimmed : null;
    }
    return null;
  }, [node?.coverUrl]);

  // ----- STATE ----- //

  const [resolvedCoverUrl, setResolvedCoverUrl] = useState(null);

  // ----- EFFECTS ----- //

  useEffect(() => {
    let cancelled = false;

    const raw = typeof coverUrl === 'string' ? coverUrl : '';
    if (!raw) {
      setResolvedCoverUrl(null);
      return undefined;
    }

    if (raw.startsWith('blob:') || raw.startsWith('data:')) {
      setResolvedCoverUrl(raw);
      return undefined;
    }

    (async () => {
      try {
        const signed = await resolveImageUrl({ nodeKey: node?.key || null, url: raw });
        if (!cancelled) setResolvedCoverUrl(signed || raw);
      } catch (e) {
        if (!cancelled) setResolvedCoverUrl(raw);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [coverUrl, node?.key]);

  // ----- RENDER ----- //

  return (

    <div
      className="node-card-container"
      onClick={onClick}
    >

      {/* TOP */}
      {coverUrl &&

        <div className="node-card-top">
          <img
            src={resolvedCoverUrl || coverUrl}
            alt=""
            aria-hidden="true"
            draggable="false"
            loading="lazy"
          />
        </div>
      }

      {/* FOOTER */}
      <div className="node-card-footer">

        {/* TITLE ROW*/}

        {/* ROW */}
        <div className="node-card-row">

          {/* TITLE */}
          {node.title && (
            <div className="node-card-title">
              {node.title}
            </div>
          )}

          {/* TYPE */}
          <div className="node-card-type">
            <NodeTypePill node={node} />
          </div>

        </div>

        {/* ROW */}
        <div className="node-card-row">

          {/* USER */}
          {node.user && node.user.name && (

            <div className="node-card-user">
              {node.user.name}
            </div>
          )}

        </div>

      </div>

    </div>
  );
};

// Dev Tools
NodeCard.displayName = 'NodeCard';

export default NodeCard;
